var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control" },
    _vm._l(_vm.checkboxes, function(checkbox, index) {
      return _c(
        "div",
        {
          staticClass: "control-item",
          class: {
            collapsible: checkbox.collapsible,
            "has-children":
              checkbox.subgroup != undefined && checkbox.subgroup.length > 0
          }
        },
        [
          _c("div", { staticClass: "form-group custom-checkbox" }, [
            _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedValues,
                      expression: "selectedValues"
                    }
                  ],
                  attrs: {
                    tabindex: "0",
                    type: "checkbox",
                    id: checkbox.value + "-filter"
                  },
                  domProps: {
                    value: checkbox.value,
                    checked: Array.isArray(_vm.selectedValues)
                      ? _vm._i(_vm.selectedValues, checkbox.value) > -1
                      : _vm.selectedValues
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.selectedValues,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = checkbox.value,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.selectedValues = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedValues = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedValues = $$c
                        }
                      },
                      function($event) {
                        return _vm.updateFilters(checkbox, $event)
                      }
                    ]
                  }
                },
                "input",
                _vm.dataAttr(checkbox),
                false
              )
            ),
            _vm._v(" "),
            _c(
              "label",
              { attrs: { tabindex: "-1", for: checkbox.value + "-filter" } },
              [_vm._v(_vm._s(checkbox.label))]
            ),
            _vm._v(" "),
            checkbox.collapsible
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle",
                        value: "collapse-" + index,
                        expression: "'collapse-' + index"
                      }
                    ],
                    staticClass: "control-expand-icon fas fa-angle-down",
                    attrs: { type: "button" }
                  },
                  [_c("span", { staticClass: "sr-only" }, [_vm._v("collapse")])]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          checkbox.subgroup != undefined && checkbox.subgroup.length
            ? _c(
                "b-collapse",
                {
                  ref: "collapse-" + index,
                  refInFor: true,
                  attrs: {
                    id: "collapse-" + index,
                    visible: checkbox.expandDefault
                  }
                },
                [
                  _c("checkbox-control", {
                    attrs: {
                      controls: checkbox.subgroup,
                      parent: checkbox,
                      specification: _vm.specification
                    },
                    on: { updatecheckboxfilter: _vm.updateCheckboxFilter }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }